import { Scalars, Exact } from "src/generated/graphql";
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { Apollo, Query } from "apollo-angular";

export class Sustainability {
    id: Scalars['ID'];
    name: Scalars['String'];
    quantity: Scalars['Float'];
    unity: Scalars['String'];
    pontuation: Scalars['Float'];
    ideaId: Scalars['ID'];
};

export class CreateSustainabilityInput {
    name: Scalars['String'];
    quantity: Scalars['Float'];
    unity: Scalars['String'];
    pontuation: Scalars['Float'];
    ideaId: Scalars['ID'];
}

export class UpdateSustainabilityInput {
    id?: Scalars['ID'];
    name?: Scalars['String'];
    quantity?: Scalars['Float'];
    unity?: Scalars['String'];
    pontuation?: Scalars['Float'];
}

export type GetSustainabilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSustainabilitiesQuery = { sustainabilities: Array<{ id: string, type?: string | null }> };

export const GetSustainabilitiesDocument = gql`
    query GetSustainabilities {
  sustainabilities {
    id
    type
  }
}
    `;

export const CreateSustainabilityDocument = gql`
    mutation CreateSustainability($data: CreateSustainabilityInput!) {
      createSustainability(data: $data) {
        name
        quantity
        unity
        pontuation
      }
    }
  `;

  export const UpdateSustainabilityDocument = gql`
    mutation UpdateSustainability($data: UpdateSustainabilityInput!) {
      updateSustainability(data: $data) {
        name
        quantity
        unity
        pontuation
      }
    }
  `;

  export const DeleteSustainabilityDocument = gql`
  mutation DeleteSustainability($id: String!) {
    deleteSustainability(id: $id) {
      message
    }
  }
`;
  
  

@Injectable({
    providedIn: 'root',
})
export class SustainabilityService {
    constructor(private apollo: Apollo) {}
  
    createSustainability(data: CreateSustainabilityInput): Promise<any> {
        return this.apollo.mutate({
        mutation: CreateSustainabilityDocument,
        variables: {
            data: data
        },
        }).toPromise();
    }

    updateSustainability(data: UpdateSustainabilityInput): Promise<any> {
        return this.apollo.mutate({
            mutation: UpdateSustainabilityDocument,
            variables: {
                data: data
            },
            }).toPromise();
    }

    deleteSustainability(id: string): Promise<any> {
      return this.apollo.mutate({
          mutation: DeleteSustainabilityDocument,
          variables: {
              id,
          },
          }).toPromise();
  }
}


@Injectable({
    providedIn: 'root'
})
export class GetSustainabilitiesGQL extends Query<GetSustainabilitiesQuery, GetSustainabilitiesQueryVariables> {
    document = GetSustainabilitiesDocument;

    constructor(apollo: Apollo) {
        super(apollo);
    }
}
